import Link from "next/link";
import { FC } from "react";

export interface TableOfContentItem {
  title?: string;
  href: string;
  id: string;
}

export interface Props {
  items: TableOfContentItem[];
}

export const TableOfContent: FC<Props> = ({ items }) => {
  return (
    <div className="kdot-container mx-auto grid grid-cols-2 gap-[24px] md:flex md:flex-wrap md:gap-[24px]">
      {items.map((item) => (
        <Link key={item.id} href={item.href} className="group inline-flex items-center  hover:text-primary">
          <div className="flex h-[20px] w-[20px] items-center justify-center rounded-full border group-hover:bg-primary group-hover:text-white">
            <svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6 9L12 15L18 9"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <span className="ml-2 text-[14px] md:text-[16px]">{item.title}</span>
        </Link>
      ))}
    </div>
  );
};
